import { CommonService } from './../../services/common.service';
import { Component, OnInit, TemplateRef, ViewChild, OnDestroy } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig, MatSnackBarRef } from '@angular/material/snack-bar';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-pcx-snackbar',
    templateUrl: './pcx-snackbar.component.html',
    styleUrls: ['./pcx-snackbar.component.scss'],
    standalone: false
})
export class PcxSnackbarComponent implements OnInit, OnDestroy {
    durationInSeconds: number = 5;
    config: MatSnackBarConfig<any>;
    snackbarRef: MatSnackBarRef<any>;
    messageText: string = '';
    actionButton: boolean = false;
    actionButtonText: string = '';
    @ViewChild('SuccessSnackbar', { static: false }) successSnackbar: TemplateRef<any>;
    @ViewChild('ErrorSnackbar', { static: false }) errorSnackbar: TemplateRef<any>;
    @ViewChild('WarnSnackbar', { static: false }) warnSnackbar: TemplateRef<any>;
    private destroy$: Subject<boolean> = new Subject<boolean>();

    constructor(
        private _snackBar: MatSnackBar,
        private _commonService: CommonService
    ) {}
    openSuccessSnackBar(config) {
        this.snackbarRef = this._snackBar.openFromTemplate(this.successSnackbar, config);
    }
    openErrorSnackBar(config) {
        this.snackbarRef = this._snackBar.openFromTemplate(this.errorSnackbar, config);
    }
    openWarnSnackBar(config) {
        this.snackbarRef = this._snackBar.openFromTemplate(this.warnSnackbar, config);
    }

    ngOnInit(): void {
        this._commonService.showToastMessageFromCustomComponent.pipe(takeUntil(this.destroy$)).subscribe(res => {
            if (res) {
                if (this.snackbarRef) {
                    this.snackbarRef.dismiss();
                }
                this.config = new MatSnackBarConfig();
                this.config['panelClass'] = 'custom-toast';
                if (res['Duration']) {
                    this.config.duration = res.Duration;
                }
                if (res['Message']) {
                    this.messageText = res.Message;
                }
                if (res['VerticalPosition']) {
                    this.config.verticalPosition = res['VerticalPosition'];
                }
                if (res['HorizontalPosition']) {
                    this.config.horizontalPosition = res['HorizontalPosition'];
                } else {
                    this.config.horizontalPosition = 'end';
                }
                if (res['ActionButton']) {
                    this.actionButton = true;
                    if (res['ActionButtonText']) {
                        this.actionButtonText = res['ActionButtonText'];
                    }
                }

                if (res.Type === 'ERROR') {
                    this.openErrorSnackBar(this.config);
                } else if (res.Type === 'WARN') {
                    this.openWarnSnackBar(this.config);
                } else {
                    this.openSuccessSnackBar(this.config);
                }
            }
        });
    }

    performAction() {
        this.snackbarRef.dismiss();
        //return this.snackbarRef.afterDismissed();
    }

    ngOnDestroy(): void {
        this.destroy$.next(true);
        this.destroy$.complete();
    }
}
